export * as resourceTypeCHeckers from './resourcesTypeCheckers';
export * from './useItemName';
export const isReactNative = () => typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
export const undefinedToNull = (value) => (value === undefined ? null : value);
export const nullToUndefined = (value) => value === undefined || value === null ? undefined : value;
